<template>
    <div>
        <v-container>
            <InitialLoading :init-loading='loading'/>
            <v-row v-if='!loading && contacts.length > 0' justify='start'>
                <v-col cols='12' md='3'>
                    <v-card outlined>
                        <!--$vuetify.breakpoint.xs-->
                        <v-card-subtitle class='pa-4 d-flex align-center justify-space-between'>
                            <span>مخاطبین</span>
                            <v-btn
                                    :elevation='$vuetify.breakpoint.xs ? 3 : 0'
                                    color='primary'
                                    :to="{name:'AddContacts'}"
                            >
                                <v-icon dark>mdi-account-plus-outline</v-icon>
                            </v-btn>
                        </v-card-subtitle>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                <tr :class="$vuetify.theme.dark ? 'blue-grey darken-4':'blue lighten-5'">
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for='contact in contacts' :key='contact._id'>
                                    <th class='pa-3' v-if='contact.user'>
                                        <User
                                            :user='contact.user'
                                            showPhone
                                            noStatus
                                        />
                                    </th>

                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-if='!loading && contacts.length === 0'>
                <v-col cols='12' class='text-center'>
                    <h4>هیچ مخاطبی ندارید</h4>
                </v-col>
            </v-row>
        </v-container>

    </div>
</template>

<script>
    import axios from 'axios';
    import User from '@/components/User';
    import InitialLoading from '@/components/initialLoading';
    import { mapActions } from 'vuex';

    export default {
        name: 'List',
        components: { InitialLoading, User },
        data() {
            return {
                inviteDetailDialog: false,
                loading: true,
                contacts: [],
                messageThreads: []
            };
        },
        methods: {
            async fetchData() {
                await axios
                    .get('/api/contact')
                    .then(res => {
                        this.contacts = res.data.contacts;
                        this.loading = false;
                    }).catch(() => {
                        this.loading = false;
                    });
            },
            ...mapActions([
                'showBreadCrumbs', 'setBreadCrumbsTemp'
            ])
        },
        async created() {
            await this.setBreadCrumbsTemp({
                key: 'contacts',
                value: {
                    text: `مخاطبین`,
                    href: `/Contacts`
                }
            });

        },
        async updated() {
            await this.showBreadCrumbs(['profile', 'contacts']);
        },
        mounted() {
            this.fetchData();
        }
    };
</script>

<style scoped>

</style>